<template>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb bg-white pl-0">
      <template v-for="item in items">
        <li
          :key="`breadcrumb-item--${item.key}`"
          class="breadcrumb-item"
          :class="getClass(item)"
          :v-bind="getBindAttributes(item)"
        >
          <span v-if="item.active">{{ item.name }}</span>

          <router-link v-else :to="item.to">
            {{ item.name }}
          </router-link>
        </li>
      </template>
    </ol>
  </nav>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  methods: {
    getClass({ active = false } = {}) {
      return {
        active
      };
    },

    getBindAttributes({ active = false } = {}) {
      const attributes = {};

      if (active) {
        this.$set(attributes, 'ariaCurrent', 'page');
      }

      return attributes;
    }
  }
};
</script>
